import { render } from "./Chatbox.vue?vue&type=template&id=5ee0ca16"
import script from "./Chatbox.vue?vue&type=script&lang=js"
export * from "./Chatbox.vue?vue&type=script&lang=js"

import "./Chatbox.vue?vue&type=style&index=0&id=5ee0ca16&lang=css"

import exportComponent from "/Users/jaspur/Code/online-alv/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__